var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeleviseur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t\\xE9l\\xE9vision"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.27,17.34H10.88A1.63,1.63,0,0,0,9.24,19V44.34A1.64,1.64,0,0,0,10.88,46H28.1v1.64H19.2a.82.82,0,1,0,0,1.64H46.12a.82.82,0,1,0,0-1.64h-9V46H54.27a1.64,1.64,0,0,0,1.64-1.64V19A1.63,1.63,0,0,0,54.27,17.34ZM35.48,47.62H29.73V46h5.75Zm11.76-3.28L29.51,26.61a.82.82,0,1,0-1.16,1.16L44.92,44.34h-34V19h8.68l5.51,5.51a.82.82,0,0,0,1.16,0,.81.81,0,0,0,0-1.15L21.87,19h32.4V44.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.32,43.56h2.51a.82.82,0,0,0,0-1.64H31.32a.82.82,0,0,0,0,1.64Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleviseur);
export default __webpack_public_path__ + "static/media/televiseur.ea9c1ee6cc1ea6567a2e2974e3cbb5ff.svg";
export { ForwardRef as ReactComponent };